import React from 'react';

const Mentions = () => {
  return (
    <main id="mentions">
      <h1>Mentions légales</h1>

      <section>
        <h2>Éditeur du site</h2>
        <p>
          Ce site est édité par : <strong>Tahin.raw</strong><br />
          Email : tahin.raw@gmail.com<br />
          Statut : Photographe indépendant (auto-entrepreneur)<br />
          SIRET : 95245048400011
        </p>
      </section>

      <section>
        <h2>Crédits</h2>
        <p>
          Conception, développement, design, CI/CD : <strong><a href="https://www.linkedin.com/in/antunesmathieu">Mathieu ANTUNES</a></strong>
        </p>
      </section>

      <section>
        <h2>Hébergement</h2>
        <p>
          Le site est hébergé par : GitHub Pages<br />
          Nom de domaine : tahinraw.fr<br />
          Enregistrement du domaine : OVH<br />
          Adresse d'OVH : 2, rue Kellermann, 59100 Roubaix
        </p>
      </section>

      <section>
        <h2>Propriété intellectuelle</h2>
        <p>
          L’ensemble des contenus présents sur ce site (photographies, logo, design...) sont la propriété exclusive de <strong>Tahin.raw</strong> sauf mention contraire.<br />
          Toute reproduction, distribution, modification ou utilisation sans autorisation préalable est strictement interdite.
        </p>
      </section>

      <section>
        <h2>Données personnelles</h2>
        <p>
          Ce site ne collecte des données personnelles que via le formulaire de contact, uniquement à des fins de réponse.<br />
          Les données ne sont ni vendues ni cédées à des tiers. Conformément à la loi « Informatique et Libertés » et au RGPD, vous pouvez exercer vos droits d’accès, de rectification ou de suppression en envoyant un email à : <strong>tahin.raw@gmail.com</strong>.
        </p>
      </section>

      <section>
        <h2>Cookies</h2>
        <p>
          Ce site n’utilise pas de cookies à des fins de suivi ou de publicité. Seuls des cookies fonctionnels peuvent être utilisés pour améliorer la navigation.
        </p>
      </section>

      <section>
        <h2>Responsabilité</h2>
        <p>
          Les informations présentées sur ce site sont données à titre indicatif. <strong>Tahin.raw</strong> ne saurait être tenu responsable de leur inexactitude ou d’une mauvaise utilisation du site.
        </p>
      </section>
    </main>
  );
};

export default Mentions;
